import { render, staticRenderFns } from "./DataScanFromProduct.vue?vue&type=template&id=d075dd1e&"
import script from "./DataScanFromProduct.vue?vue&type=script&lang=ts&"
export * from "./DataScanFromProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports